module.exports = __webpack_public_path__ + "img/icon4.24438059.png";